export const CONSTRUCTION_YEAR_MAP: Record<string, ConstructionYearRange> = {
  '0': { max: '', min: '' },
  '1': { max: '1933', min: '' },
  '2': { max: '1957', min: '1934' },
  '3': { max: '1964', min: '1958' },
  '4': { max: '1974', min: '1965' },
  '5': { max: '1993', min: '1975' },
  '6': { max: '2009', min: '1994' },
  '7': { max: '', min: '2010' },
};
type ConstructionYearRange = {
  max: string;
  min: string;
};
